/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EnumerationEvaluationParameterDto } from './EnumerationEvaluationParameterDto';
import {
    EnumerationEvaluationParameterDtoFromJSON,
    EnumerationEvaluationParameterDtoFromJSONTyped,
    EnumerationEvaluationParameterDtoToJSON,
} from './EnumerationEvaluationParameterDto';
import type { EnumerationEvaluationResultDto } from './EnumerationEvaluationResultDto';
import {
    EnumerationEvaluationResultDtoFromJSON,
    EnumerationEvaluationResultDtoFromJSONTyped,
    EnumerationEvaluationResultDtoToJSON,
} from './EnumerationEvaluationResultDto';
import type { ResultHistoryEntryDto } from './ResultHistoryEntryDto';
import {
    ResultHistoryEntryDtoFromJSON,
    ResultHistoryEntryDtoFromJSONTyped,
    ResultHistoryEntryDtoToJSON,
} from './ResultHistoryEntryDto';

/**
 * 
 * @export
 * @interface EnumerationDataPointDetailsDto
 */
export interface EnumerationDataPointDetailsDto {
    /**
     * 
     * @type {Array<ResultHistoryEntryDto>}
     * @memberof EnumerationDataPointDetailsDto
     */
    history?: Array<ResultHistoryEntryDto> | null;
    /**
     * 
     * @type {EnumerationEvaluationResultDto}
     * @memberof EnumerationDataPointDetailsDto
     */
    evaluationResult: EnumerationEvaluationResultDto;
    /**
     * 
     * @type {EnumerationEvaluationParameterDto}
     * @memberof EnumerationDataPointDetailsDto
     */
    evaluationParameter: EnumerationEvaluationParameterDto;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataPointDetailsDto
     */
    $type?: EnumerationDataPointDetailsDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationDataPointDetailsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoEnumerationDataPointDetailsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataPointDetailsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationDataPointDetailsDtoTypeEnum = typeof EnumerationDataPointDetailsDtoTypeEnum[keyof typeof EnumerationDataPointDetailsDtoTypeEnum];


/**
 * Check if a given object implements the EnumerationDataPointDetailsDto interface.
 */
export function instanceOfEnumerationDataPointDetailsDto(value?: unknown): value is EnumerationDataPointDetailsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationDataPointDetailsDtoTypeEnum)[0];
}

export function EnumerationDataPointDetailsDtoFromJSON(json: any): EnumerationDataPointDetailsDto {
    return EnumerationDataPointDetailsDtoFromJSONTyped(json, false);
}

export function EnumerationDataPointDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationDataPointDetailsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'history': !exists(json, 'history') ? undefined : (json['history'] === null ? null : (json['history'] as Array<any>).map(ResultHistoryEntryDtoFromJSON)),
        'evaluationResult': EnumerationEvaluationResultDtoFromJSON(json['evaluationResult']),
        'evaluationParameter': EnumerationEvaluationParameterDtoFromJSON(json['evaluationParameter']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EnumerationDataPointDetailsDtoToJSON(value?: EnumerationDataPointDetailsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'history': value.history === undefined ? undefined : (value.history === null ? null : (value.history as Array<any>).map(ResultHistoryEntryDtoToJSON)),
        'evaluationResult': EnumerationEvaluationResultDtoToJSON(value.evaluationResult),
        'evaluationParameter': EnumerationEvaluationParameterDtoToJSON(value.evaluationParameter),
        '$type': value.$type,
    });
}

